import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { CalendarCheck2, Link2Off } from "lucide-react";
import { useApi, errMsg, fmtDate } from "@/lib/api";

const MSG = { connected: ["success", "Google Calendar connected — new bookings will appear on it"], cancelled: ["warning", "Google connection was cancelled"], failed: ["error", "Google connection failed, please try again"], invalid: ["error", "That connection link expired, please try again"] };

export const GoogleCalendarCard = () => {
  const api = useApi();
  const [params, setParams] = useSearchParams();
  const [s, setS] = useState(null);
  useEffect(() => {
    api("get", "/google-calendar/status").then(setS).catch(() => {});
    const g = params.get("gcal");
    if (g && MSG[g]) {
      toast[MSG[g][0]](MSG[g][1]);
      params.delete("gcal");
      setParams(params, { replace: true });
    }
  }, [api]); // eslint-disable-line react-hooks/exhaustive-deps

  const connect = async () => {
    try {
      window.location.href = (await api("get", "/google-calendar/connect")).authorization_url;
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const disconnect = async () => {
    if (!window.confirm("Stop sending bookings to Google Calendar?")) return;
    await api("post", "/google-calendar/disconnect");
    setS({ ...s, connected: false, email: "" });
  };

  if (!s || !s.configured) return null;
  return (
    <div className="mb-6 flex flex-col gap-3 rounded-2xl border border-[#E6E2DA] bg-white p-5 sm:flex-row sm:items-center sm:justify-between" data-testid="gcal-card">
      <div className="flex items-start gap-3">
        <CalendarCheck2 className="mt-0.5 shrink-0 text-[#A67C00]" size={22} />
        <div>
          <p className="font-semibold">Google Calendar</p>
          <p className="text-sm text-[#5C5850]" data-testid="gcal-status">
            {!s.configured ? "Waiting for Google keys to be added." : s.connected ? `Connected to ${s.email} since ${fmtDate(s.connected_at)}. Website bookings are added automatically.` : "Not connected. Connect firmfoundationsconstruction.1@gmail.com to get every website booking on your phone's calendar."}
          </p>
        </div>
      </div>
      {s.configured && (s.connected
        ? <button onClick={disconnect} data-testid="gcal-disconnect-btn" className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#E6E2DA] px-4 py-2 text-sm font-semibold hover:border-red-600 hover:text-red-600"><Link2Off size={14} />Disconnect</button>
        : <button onClick={connect} data-testid="gcal-connect-btn" className="shrink-0 rounded-full bg-[#F2B91C] px-5 py-2.5 text-sm font-bold text-[#0E1F3F] hover:bg-[#D9A30F]">Connect Google Calendar</button>)}
    </div>
  );
};
